module.exports = __webpack_public_path__ + "media/customizations/jordanranch/back-a905efc1ff1630add68647fa942f0681.jpg";